import { render, staticRenderFns } from "./zyf.vue?vue&type=template&id=ba43bfd2&scoped=true"
import script from "./zyf.vue?vue&type=script&lang=js"
export * from "./zyf.vue?vue&type=script&lang=js"
import style0 from "./zyf.vue?vue&type=style&index=0&id=ba43bfd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba43bfd2",
  null
  
)

export default component.exports